"use client";

import { MapPin, Clock, Facebook, Instagram, Mail, Phone } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MapaAAdresa() {
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: infoRef,
    isVisible: infoVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="mapa-a-adresa" className="dark bg-background text-foreground relative overflow-hidden">
      {}
      <div ref={mapRef} className="relative bg-accent border-y border-border transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] opacity-100 scale-100 !h-[1px] hover:h-[520px]">
        {}
        

        {}
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent pointer-events-none" />
      </div>

      {}
      <div className="container mx-auto px-4 py-16">
        <div ref={infoRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${infoVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <Card className="group hover:border-primary/30 transition-all duration-[var(--duration-medium)]" style={{
          transitionDelay: infoVisible ? "0ms" : "0ms"
        }}>
            <CardContent className="flex flex-col items-start gap-4 pt-6">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-[var(--duration-medium)]">
                <MapPin className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2 text-foreground">Adresa</h3>
                <p className="text-muted-foreground leading-relaxed">Chrudim<br />Česká republika</p>
              </div>
            </CardContent>
          </Card>

          {}
          <Card className="group hover:border-primary/30 transition-all duration-[var(--duration-medium)]" style={{
          transitionDelay: infoVisible ? "100ms" : "0ms"
        }}>
            <CardContent className="flex flex-col items-start gap-4 pt-6">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-[var(--duration-medium)]">
                <Clock className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2 text-foreground">Otevírací doba</h3>
                <p className="text-muted-foreground leading-relaxed">Po-Pá: 8:00-18:00</p>
              </div>
            </CardContent>
          </Card>

          {}
          <Card className="group hover:border-primary/30 transition-all duration-[var(--duration-medium)]" style={{
          transitionDelay: infoVisible ? "200ms" : "0ms"
        }}>
            <CardContent className="flex flex-col items-start gap-4 pt-6">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-[var(--duration-medium)]">
                <Mail className="w-6 h-6 text-primary" />
              </div>
              <div className="w-full">
                <h3 className="text-lg font-semibold mb-3 text-foreground">Kontakt</h3>
                <div className="space-y-2 mb-4">
                  <Link to="tel:+420732438067" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors duration-[var(--duration-medium)] group/link">
                    <Phone className="w-4 h-4" />
                    <span className="text-sm">+420 732 438 067</span>
                  </Link>
                  <Link to="mailto:cisteni.renovacestrech@gmail.com" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors duration-[var(--duration-medium)] group/link">
                    <Mail className="w-4 h-4" />
                    <span className="text-sm break-all">cisteni.renovacestrech@gmail.com</span>
                  </Link>
                </div>
                <div className="flex gap-3 pt-2 border-t border-border">
                  <Link to="#" className="w-10 h-10 rounded-lg bg-secondary hover:bg-primary hover:text-foreground-primary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-1" aria-label="Facebook">
                    <Facebook className="w-5 h-5" />
                  </Link>
                  <Link to="#" className="w-10 h-10 rounded-lg bg-secondary hover:bg-primary hover:text-foreground-primary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-1" aria-label="Instagram">
                    <Instagram className="w-5 h-5" />
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}